"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.PageTitle = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _jsxRuntime = require("react/jsx-runtime");

var _react = require("@fluentui/react");

var React = _interopRequireWildcard(require("react"));

var _useTheme = require("../hooks/useTheme");

var _stylingConstants = require("../styling/stylingConstants");

var getClassNames = (0, _react.classNamesFunction)();

var PageTitleBase = function PageTitleBase(_ref) {
  var className = _ref.className,
      styles = _ref.styles,
      children = _ref.children;
  var theme = (0, _useTheme.useTheme)();
  var classes = getClassNames(styles, {
    theme: theme
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    role: "heading",
    "aria-level": 1,
    className: (0, _react.css)('ms-PageTitle', className, classes.root),
    children: children
  });
};

var PageTitle = (0, _react.styled)(PageTitleBase, function (_ref2) {
  var fonts = _ref2.theme.fonts;
  return {
    root: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, fonts.xxLarge), {}, {
      fontWeight: _react.FontWeights.regular,
      marginBottom: "".concat(_stylingConstants.gridUnit * 3, "px")
    })
  };
});
exports.PageTitle = PageTitle;